<template>
  <div class="home">
    <homeComponent />
    <!-- <HomestatsComponent /> -->
    <BlockctaComponent />
    <section id="why">
      <paragraphRepeaterComponent />
    </section>
    <section id="how">
    <TextSidebarComponent />
    </section>
    <section id="companySurvey">
    <textBlocksComponent />
    </section>
    <section class="block-partners" id="partners">
    <BlockLogoPartnerComponent />
    </section>
    <section class="block-text-image" id="useofdata">
    <BlocktextimageComponent />
    </section>
    <section class="block-faq" id="faq">
    <FAQComponent />
    </section>
  </div>
</template>

<script>

// @ is an alias to /src
import homeComponent from '@/components/Home.vue';
// import HomestatsComponent from '@/components/Homestats.vue';
import BlockctaComponent from '@/components/Blockcta.vue';
import paragraphRepeaterComponent from '@/components/ParagraphRepeater.vue';
import TextSidebarComponent from '@/components/TextSidebar.vue';
import TextBlocksComponent from '@/components/TextBlocks.vue';
import BlocktextimageComponent from '@/components/Blocktextimage.vue';
import BlockLogoPartnerComponent from '@/components/BlockLogoPartner.vue';
import FAQComponent from '@/components/FAQ.vue';

/* eslint-disable no-console */
export default {
  name: 'Home',
  components: {
    homeComponent,
    // HomestatsComponent,
    BlockctaComponent,
    paragraphRepeaterComponent,
    TextSidebarComponent,
    TextBlocksComponent,
    BlocktextimageComponent,
    BlockLogoPartnerComponent,
    FAQComponent,
  },
};
</script>
